export default "__VITE_ASSET__Bu0V8MG___"